import * as React from 'react';

const SvgNavInterfaces = (props) => React.createElement(
  "svg",
  Object.assign({ xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 24 24", height: props.size, width: props.size }, props),
  React.createElement("path", { fill: "#2D2E2E", d: "M7.5 7.5v9h9V21H3V3h18v13.5h-4.5v-9h-9Z" })
);

export { SvgNavInterfaces as default };
//# sourceMappingURL=NavInterfaces.es.js.map
